import { sendSocketMessage, socketMessageStream } from "./socketStream";
import { first, map, timeout } from "rxjs/operators";
import { generateRandomId } from "./session";
import store from "../store";

let instance = null;

class CoPilot {
    constructor() {
        this.siteId = store.state.site.site._id;
    }

    /**
     * @return {CoPilot}
     */

    static getInstance() {
        if (instance === null) {
            instance = new CoPilot();
        }
        return instance;
    }

    async fixGrammar(message, options) {
        const id = generateRandomId();
        const payload = {
            siteId: this.siteId,
            message,
            id,
        };
        if (options && options.service) payload.service = options.service;
        if (options && options.user) payload.user = options.user;
        if (options && options.visitor) payload.visitor = options.visitor;
        if (options && options.conversationId) payload.conversationId = options.conversationId;
        sendSocketMessage("copilot fix-grammar", payload);
        return socketMessageStream
            .pipe(
                first((message) => message.cmd === "copilot_response" && message.data.id === id),
                map((message) => message.data.result),
                timeout(120000)
            )
            .toPromise();
    }

    async longSentence(message, options) {
        const id = generateRandomId();
        const payload = {
            siteId: this.siteId,
            message,
            id,
        };
        if (options && options.service) payload.service = options.service;
        if (options && options.user) payload.user = options.user;
        if (options && options.visitor) payload.visitor = options.visitor;
        if (options && options.conversationId) payload.conversationId = options.conversationId;
        sendSocketMessage("copilot long-sentence", payload);
        return socketMessageStream
            .pipe(
                first((message) => message.cmd === "copilot_response" && message.data.id === id),
                map((message) => message.data.result),
                timeout(120000)
            )
            .toPromise();
    }

    async changeTone(message, tone, options) {
        const id = generateRandomId();
        const payload = {
            siteId: this.siteId,
            message,
            id,
            tone,
        };
        if (options && options.service) payload.service = options.service;
        if (options && options.user) payload.user = options.user;
        if (options && options.visitor) payload.visitor = options.visitor;
        if (options && options.conversationId) payload.conversationId = options.conversationId;
        sendSocketMessage("copilot change-tone", payload);
        return socketMessageStream
            .pipe(
                first((message) => message.cmd === "copilot_response" && message.data.id === id),
                map((message) => message.data.result),
                timeout(120000)
            )
            .toPromise();
    }

    async recommendAnswer(siteId, userId, conversationId) {
        console.log("recommendAnswer", { siteId, userId, conversationId });
        const id = generateRandomId();
        sendSocketMessage("copilot recommend-answer", { siteId, userId, conversationId, id });
        return socketMessageStream
            .pipe(
                first((message) => message.cmd === "copilot_response" && message.data.id === id),
                map((message) => message.data.result),
                timeout(120000)
            )
            .toPromise();
    }

    async ticketAiresponse(siteId, userId, ticketMessage, osrPayload) {
        console.log("ticketAiresponse", { siteId, userId, ticketMessage, osrPayload });
        const id = generateRandomId();
        sendSocketMessage("copilot ticket-ai-response", { siteId, userId, ticketMessage, osrPayload, id });
        return socketMessageStream
            .pipe(
                first((message) => message.cmd === "copilot_response" && message.data.id === id),
                map((message) => message.data.result),
                timeout(120000)
            )
            .toPromise();
    }

    async summarizeContent(content) {
        const id = generateRandomId();
        sendSocketMessage("copilot summarize-content", {
            siteId: this.siteId,
            content,
            id,
        });
        return socketMessageStream
            .pipe(
                first((message) => message.cmd === "copilot_response" && message.data.id === id),
                map((message) => message.data.result),
                timeout(120000)
            )
            .toPromise();
    }

    async analyzeSentiment(content) {
        const id = generateRandomId();
        sendSocketMessage("copilot analyze-sentiment", {
            siteId: this.siteId,
            content,
            id,
        });
        return socketMessageStream
            .pipe(
                first((message) => message.cmd === "copilot_response" && message.data.id === id),
                map((message) => message.data.result),
                timeout(120000)
            )
            .toPromise();
    }

    async messageTranslation(message, languageCode, options) {
        const id = generateRandomId();
        const payload = {
            siteId: this.siteId,
            message,
            languageCode,
            id,
        };
        if (options && options.service) payload.service = options.service;
        if (options && options.user) payload.user = options.user;
        if (options && options.visitor) payload.visitor = options.visitor;
        if (options && options.conversationId) payload.conversationId = options.conversationId;
        sendSocketMessage("copilot message-translation", payload);
        return socketMessageStream
            .pipe(
                first((message) => message.cmd === "copilot_response" && message.data.id === id),
                map((message) => message.data.result),
                timeout(120000)
            )
            .toPromise();
    }

    async promptToGenerateResponse(siteId, userId, conversationId, message) {
        console.log("promptToGenerateResponse", { siteId, userId, conversationId, message });
        const id = generateRandomId();
        sendSocketMessage("copilot prompt-to-generate-response", { siteId, userId, conversationId, message, id });
        return socketMessageStream
            .pipe(
                first((message) => message.cmd === "copilot_response" && message.data.id === id),
                map((message) => message.data.result),
                timeout(120000)
            )
            .toPromise();
    }

    async mailAiresponse(siteId, userId, mailDetails) {
        console.log("mailAiresponse", { siteId, userId, mailDetails });
        const id = generateRandomId();
        sendSocketMessage("copilot mail-ai-response", { siteId, userId, mailDetails, id });
        return socketMessageStream
            .pipe(
                first((message) => message.cmd === "copilot_response" && message.data.id === id),
                map((message) => message.data.result),
                timeout(120000)
            )
            .toPromise();
    }

    async mailPromtMessage(siteId, userId, mailDetails, message) {
        console.log("mailPromtMessage", mailDetails, message);
        const id = generateRandomId();
        sendSocketMessage("copilot mail-promt-message", { siteId, userId, mailDetails, message, id });
        return socketMessageStream
            .pipe(
                first((message) => message.cmd === "copilot_response" && message.data.id === id),
                map((message) => message.data.result),
                timeout(120000)
            )
            .toPromise();
    }

    async getSessionRecommendations(data) {
        const id = generateRandomId();
        sendSocketMessage("copilot session-recommendation", { ...data, id });
        return socketMessageStream
            .pipe(
                first((message) => message.cmd === "copilot_response" && message.data.id === id),
                map((message) => message.data.result),
                timeout(120000)
            )
            .toPromise();
    }

    async createWorkspaceAppModules(data) {
        const id = generateRandomId();
        sendSocketMessage("copilot create-workspace", { ...data, id });
        return socketMessageStream
            .pipe(
                first((message) => message.cmd === "copilot_response" && message.data.id === id),
                map((message) => message.data.result),
                timeout(120000)
            )
            .toPromise();
    }

    async createTableReports(data) {
        const id = generateRandomId();
        sendSocketMessage("copilot create-table-reports", { ...data, id });
        return socketMessageStream
            .pipe(
                first((message) => message.cmd === "copilot_response" && message.data.id === id),
                map((message) => message.data.result),
                timeout(120000)
            )
            .toPromise();
    }

    async runTableAgent(data) {
        const id = generateRandomId();
        sendSocketMessage("copilot run-table-agent", { ...data, id });
        return socketMessageStream
            .pipe(
                first((message) => message.cmd === "copilot_response" && message.data.id === id),
                map((message) => message.data.result),
                timeout(120000)
            )
            .toPromise();
    }

    async createFormula(data) {
        const id = generateRandomId();
        sendSocketMessage("copilot create-formula", { ...data, id });
        return socketMessageStream
            .pipe(
                first((message) => message.cmd === "copilot_response" && message.data.id === id),
                map((message) => message.data.result),
                timeout(120000) // 30 saniye timeout
            )
            .toPromise();
    }

    async generateVoiceResponse(customerPrompt) {
        const id = generateRandomId();
        sendSocketMessage("copilot run-voice-agent", {
            siteId: this.siteId,
            customerPrompt,
            id,
        });
        return socketMessageStream
            .pipe(
                first((message) => message.cmd === "copilot_response" && message.data.id === id),
                map((message) => message.data.result),
                timeout(120000) // 30 saniye timeout
            )
            .toPromise();
    }

    async generateJavaScriptCode(data) {
        const id = generateRandomId();
        sendSocketMessage("copilot generate-javascript", {
            ...data,
            id,
        });
        return socketMessageStream
            .pipe(
                first((message) => message.cmd === "copilot_response" && message.data.id === id),
                map((message) => message.data.result),
                timeout(120000) // 60 saniye timeout
            )
            .toPromise();
    }

    async generateChatbotJavaScriptCode(data) {
        const id = generateRandomId();
        sendSocketMessage("copilot generate-chatbot-javascript", {
            ...data,
            id,
        });
        return socketMessageStream
            .pipe(
                first((message) => message.cmd === "copilot_response" && message.data.id === id),
                map((message) => message.data.result),
                timeout(120000) // 60 saniye timeout
            )
            .toPromise();
    }

    async suggestFilters(data) {
        const id = generateRandomId();
        sendSocketMessage("copilot suggest-filters", {
            siteId: this.siteId,
            ...data,
            id,
        });
        return socketMessageStream
            .pipe(
                first((message) => message.cmd === "copilot_response" && message.data.id === id),
                map((message) => message.data.result),
            )
            .toPromise();
    }
}

export default CoPilot;
